export default function getExtensionFromFileName(fileName) {
  if (fileName) {
    const splitFileName = fileName.split('.');
    if (splitFileName.length > 1) {
      const extension = splitFileName.pop();
      return `.${extension.toLowerCase()}`;
    }
  }
  return '';
}
